"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("../scss/main.scss");
const govuk_frontend_1 = require("govuk-frontend");
(0, govuk_frontend_1.initAll)();
document.querySelectorAll('[data-app-print-page]').forEach(button => {
    button.addEventListener('click', () => window.print());
});
